"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCountryCodePropertyOption = exports.isCountryCodeProperty = exports.countryCodePropertyDefinition = void 0;
const models_1 = require("../models");
const defaultCountryCodePropertyOptions = models_1.countryCodes;
const countryCodePropertyOptions = [...defaultCountryCodePropertyOptions, 'AN'];
exports.countryCodePropertyDefinition = {
    view: { label: 'Country code' },
    constraints: [
        {
            name: 'options',
            argument: defaultCountryCodePropertyOptions,
        },
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'select',
    multiple: false,
    name: 'country-code',
};
const isCountryCodeProperty = (prop) => {
    return prop.name === exports.countryCodePropertyDefinition.name;
};
exports.isCountryCodeProperty = isCountryCodeProperty;
const isCountryCodePropertyOption = (option) => {
    return countryCodePropertyOptions.includes(option);
};
exports.isCountryCodePropertyOption = isCountryCodePropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291bnRyeS1jb2RlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY291bnRyeS1jb2RlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLHNDQUF3QztBQUV4QyxNQUFNLGlDQUFpQyxHQUFHLHFCQUFZLENBQUE7QUFFdEQsTUFBTSwwQkFBMEIsR0FBRyxDQUFDLEdBQUcsaUNBQWlDLEVBQUUsSUFBSSxDQUFDLENBQUE7QUFFbEUsUUFBQSw2QkFBNkIsR0FBRztJQUMzQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsY0FBYyxFQUFFO0lBQy9CLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFNBQVM7WUFDZixRQUFRLEVBQUUsaUNBQWlDO1NBQzVDO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsUUFBUTtJQUNkLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGNBQWM7Q0FDVyxDQUFBO0FBSTFCLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxJQUFrQixFQUErQixFQUFFO0lBQ3ZGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxxQ0FBNkIsQ0FBQyxJQUFJLENBQUE7QUFDekQsQ0FBQyxDQUFBO0FBRlksUUFBQSxxQkFBcUIseUJBRWpDO0FBSU0sTUFBTSwyQkFBMkIsR0FBRyxDQUFDLE1BQWMsRUFBdUMsRUFBRTtJQUNqRyxPQUFPLDBCQUEwQixDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQTtBQUNwRCxDQUFDLENBQUE7QUFGWSxRQUFBLDJCQUEyQiwrQkFFdkMifQ==